import { inject, injectable } from 'inversify'
import { PlayerModule } from '../api'
import { SectionStateService, SectionStateServiceSymbol } from './section-state-service'

@injectable()
export class SectionStatePlayerModule implements PlayerModule {

  readonly name = 'section-state'

  constructor(
    @inject(SectionStateServiceSymbol)
    private sectionStateService: SectionStateService) {}

  start(): void {
    this.sectionStateService.start();
  }

  reset(): void {
  }

  async stop() {
    await this.sectionStateService.finish()
  }
}
